import accommodationApi from '../api/accommodation';
import editRideApi from '../api/editRide';
import extraInformationApi from '../api/extraInformationForRide';
import { runAttachOperations } from '../utils/runAttachOperations';

const defaultApi = {
  createAccommodation: (token, rideId, body) =>
    accommodationApi.createAccommodation(token, rideId, body),
  createAttraction: (token, rideId, body) =>
    editRideApi.createAttraction(token, rideId, body),
  addExtraInformation: (token, body) =>
    extraInformationApi.addExtraInformationForRide(token, body),
};

/**
 * Performs the writes produced by buildAttachOperations against one ride.
 *
 * Nothing but endpoint wiring lives here: runAttachOperations holds the logic,
 * kept import-free so the plain-node test runner can drive it with a fake API.
 * See its header for what the returned lists mean — in particular why stay and
 * place failures (`errors`) are reported apart from day-note and
 * general-information failures (`extraInfoErrors`).
 */
export async function attachParsedDocuments({ apptoken, rideId, operations, api = defaultApi }) {
  return runAttachOperations({ apptoken, rideId, operations, api });
}

export default { attachParsedDocuments };
